import "../../styles/diagram-editor.scss";
import "../../styles/menu.scss";

export { awaitRedraw } from "@dhx/ts-common/dom";
export { DataCollection, DataEvents } from "@dhx/ts-data";
export { shapes as DiagramShapes } from "./components/shapeFactory";
export { Diagram } from "@dhx/ts-diagram";

import { View } from "@dhx/ts-common/view";
import { extend } from "@dhx/ts-common/core";
import {
	OrgChartEditor,
	FreeEditor,
	IDefaultEditorConfig,
	IOrgEditorConfig,
	IMindmapEditorConfig,
	IDiagramEditor,
	DiagramEditorEvents,
	IDiagramEditorHandlersMap,
	IEditorConfig,
	HistoryManager,
	ViewMode,
} from "@dhx/ts-diagram-editor";
import { IDataItem } from "@dhx/ts-data";
import locale from "./locales/en";
import { IEventSystem } from "@dhx/ts-common/events";
import { DataEvents, DiagramEvents, SelectionEvents } from "./types";
import { Diagram } from "@dhx/ts-diagram";

const w = window as any;
export const i18n: any = w.dhx && w.dhx.i18n ? w.dhx.i18 : {};
i18n.setLocale = function(component: string, value: any) {
	const target = i18n[component];
	for (const key in value) {
		target[key] = value[key];
	}
};
i18n.diagram = i18n.diagram || locale;

export class DiagramEditor extends View implements IDiagramEditor {
	public version: string;
	public config: IDefaultEditorConfig | IOrgEditorConfig | IMindmapEditorConfig | IEditorConfig;
	public events: IEventSystem<
		DataEvents | SelectionEvents | DiagramEvents | DiagramEditorEvents,
		IDiagramEditorHandlersMap
	>;
	public diagram: Diagram;
	public history: HistoryManager;

	constructor(
		container: string | HTMLElement,
		config: IDefaultEditorConfig | IOrgEditorConfig | IMindmapEditorConfig = {} as any
	) {
		super(container, config);

		let editor: DiagramEditor | FreeEditor | OrgChartEditor;
		const orgTypes: string[] = ["org", "mindmap"];

		if (orgTypes.includes(config.type)) {
			editor = new OrgChartEditor(container, config as IOrgEditorConfig | IMindmapEditorConfig);
		} else {
			editor = new FreeEditor(container, config as IDefaultEditorConfig);
		}
		extend(this, editor);
	}
	paint(): void {
		return;
	}
	import(diagram: Diagram): void {
		return;
	}
	parse(data: IDataItem[]): void {
		return;
	}
	serialize(): IDataItem[] {
		return [];
	}
	zoomIn(step: number): void {
		return;
	}
	zoomOut(step: number): void {
		return;
	}
	setViewMode(mode: ViewMode): void {
		return;
	}
}
